import React, {useCallback, useMemo} from 'react';
import {Face} from 'components/customer/Product/Drawer/helpers/componentFaces';
import {PresetRow} from 'components/customer/Product/Drawer/PresetRow';
import {
    buildPresets,
    faceShape,
    shapesMatch,
    withCustom,
} from 'components/customer/Product/Drawer/helpers/drawerPresets';

interface ComponentFacePresetsProps {
    faces: Face[];
    total: number;
    onApply: (shape: (number | null)[]) => void;
}

// The total a drawer face product declares already has the gaps taken out, so
// it is the space the presets divide with nothing further to subtract.
export const ComponentFacePresets = ({
    faces,
    total,
    onApply,
}: ComponentFacePresetsProps) => {
    const presets = useMemo(() => {
        if (faces.length === 0) return [];

        const current = faceShape(
            faces.map((face) => face.height),
            faces.map((face) => face.isAuto)
        );

        return withCustom(
            buildPresets(faces.length, total),
            current,
            faces.map((face) => face.height)
        ).map((preset) => ({
            ...preset,
            isActive: shapesMatch(preset.heights, current),
        }));
    }, [faces, total]);

    const applyHandler = useCallback(
        (index: number) => {
            const preset = presets[Number(index)];

            if (!preset || preset.isCustom) return;

            onApply(preset.heights);
        },
        [presets, onApply]
    );

    return <PresetRow presets={presets} onApply={applyHandler} />;
};
